/**
 * qiyu customer service config
 */
const QIYU_CONFIG = {
  // app config
  APP_KEY: 'a8d0445a3ed9b92d7244efbf158dc527',
  ENVIRONMENT: 'overseas',

  // robot config
  ROBOT_CONFIG: {
    hk: {
      // robotId: 5328340,
      templateId: 6638243,
      language: 'zh-tw',
      shuntId: '1095476',
    },
    en: {
      // robotId: 5329354,
      templateId: 6638243,
      language: 'en',
      shuntId: '1095476',
    },
  },

  // default config
  DEFAULTS: {
    language: 'en',
    uid: '', // 7599457
    accountCard: '', // 752299990630
    schoolCode: '415',
    schoolTag: 'US',
    referrer: '',
    title: '',
  },

  // 认证配置
  AUTH: {
    secret: 'hwlzam9zzhgfg7g',
  },
}

export default QIYU_CONFIG
